import React from 'react'
import './style.scss'

export default ({ text="Com a segurança" }) => 
    <div className="SantanderLabel">
        {text}
        <img src="/assets/img/santander.svg" title="Santander" alt="Santander" width={110} height={25} />
    </div>
